import actions from './actions';

const initState = { accesses: null };

export default function logReducer(state = initState, action) {
  switch (action.type) {
    case actions.ACCESS_SEARCH_SUCCESS:
      return { ...state, accesses: action.accesses };
    case actions.ACCESS_ACTIONS_SEARCH_SUCCESS:
      return { ...state, accessActions: action.accessActions };
    case actions.ACCESS_CREATE_SUCCESS:
      return { ...state, accessCreateSuccess: action.accessCreateSuccess };
    case actions.ACCESS_UPDATE_SUCCESS:
      return { ...state, accessUpdateSuccess: action.accessUpdateSuccess };
    case actions.ACCESS_DELETE_SUCCESS:
      return { ...state, accessDeleteSuccess: action.accessDeleteSuccess };
    case actions.ACCESS_ERROR:
      return { ...state, accessError: action.accessError };
    default:
      return state;
  }
}
